import type { AasApiAdapter, ModelCatalogFilters } from "../adapter";
import { requestJson } from "../http";
import type { ModelCatalogResponse } from "../types";

export const modelsApi: AasApiAdapter["models"] = {
	async list(filters: ModelCatalogFilters = {}) {
		return requestJson<ModelCatalogResponse>("/api/models", {
			query: {
				provider: filters.provider,
				q: filters.q,
				harness: filters.harness,
			},
		});
	},
};
